import controller from './account-settings.controller';

const template = require('./account-settings.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/account-settings/account-settings.component.js